export default function getIsSignupEligibleForFundIt(signupListTypeID) {
    return typeof signupListTypeID === 'number' && MONETIZEABLE_SIGNUP_TYPES.has(signupListTypeID);
}

// TODO a better way of getting/knowing if signup is eligible for FundIt
// TODO follow up: can you really monetize a poll?
/*
abstract class SignupListTypes extends Enum
{
    public const Event = 1;
    public const Seats = 2;
    public const Appointment = 3;
    public const Poll = 4;
    public const Items = 5;
    public const Raffle = 6;
    public const Volunteers = 7;
    public const Potluck = 8;
}
 */
const MONETIZEABLE_SIGNUP_TYPES = new Set([1, 2, 4, 5]);
